<nav *ngIf="tipoNavbar === 'padrao'" class="navbar navbar-expand-lg navbar-light bg-white shadow-sm">
  <div class="container-fluid">
    <a class="navbar-brand" href="/home">
      <img src="ExBe_monogram.png" alt="Logo Exbe" height="60">
    </a>

    <ul class="navbar-nav ms-auto">
      <li class="nav-item dropdown">
        <a class="nav-link dropdown-toggle text-dark" href="#" id="navbarDropdown"
           role="button" data-bs-toggle="dropdown" aria-expanded="false">

          <img 
            *ngIf="fotoUsuario; else defaultFoto"
            [src]="fotoUsuario"
            class="rounded-circle object-fit-cover me-2"
            style="width: 35px; height: 35px;" />
          <ng-template #defaultFoto>
            <i class="bi bi-person-circle me-2 fs-4"></i>
          </ng-template>

          <span>{{nomeUsuario}}</span>
        </a>

        <ul class="dropdown-menu dropdown-menu-end" aria-labelledby="navbarDropdown">
          <li><a class="dropdown-item" href="#">Meu Perfil</a></li>
          <li><a class="dropdown-item" href="#">Configurações</a></li>
          <li><hr class="dropdown-divider"></li>
          <li><a class="dropdown-item text-danger" (click)="Sair()">
            <i class="bi bi-box-arrow-right me-2"></i>Sair 
          </a></li>
        </ul>
      </li>
    </ul>
  </div>
</nav>

<nav *ngIf="tipoNavbar === 'exbeOn'" class="navbar navbar-expand-lg navbar-light bg-white shadow-sm">
  <div class="container-fluid">
    <a class="navbar-brand" href="/home">
      <img src="ExBe_monogram.png" alt="Logo Exbe" height="60">
    </a>
    <h2 class="page-title mb-0 ms-3" style="color: #0073CF">ExbeOn</h2>
    
    <ul class="navbar-nav ms-auto">
      <li class="nav-item dropdown">
        <a class="nav-link dropdown-toggle text-dark" href="#" id="navbarDropdownExbeon" 
           role="button" data-bs-toggle="dropdown" aria-expanded="false">
          
          <img 
            *ngIf="fotoUsuario; else defaultFotoExbeon"
            [src]="fotoUsuario"
            class="rounded-circle object-fit-cover me-2"
            style="width: 35px; height: 35px;" />
          <ng-template #defaultFotoExbeon>
            <i class="bi bi-person-circle me-2 fs-4"></i>
          </ng-template>

          <span>{{nomeUsuario}}</span>
        </a>
        
        <ul class="dropdown-menu dropdown-menu-end" aria-labelledby="navbarDropdownExbeon">
          <li><a class="dropdown-item" href="#">Meu Perfil</a></li>
          <li><a class="dropdown-item" href="#">Configurações</a></li>
          <li><hr class="dropdown-divider"></li>
          <li><a class="dropdown-item text-danger" href="/login">
            <i class="bi bi-box-arrow-right me-2"></i>Sair
          </a></li>
        </ul>
      </li>
    </ul>
  </div>
</nav>

<header *ngIf="tipoNavbar === 'guardian'" class="main-header">
  <nav class="navbar navbar-expand-lg navbar-light bg-white">
    <div class="container-fluid">
      <div class="d-flex align-items-center">
        <a class="navbar-brand" href="/home">
          <img src="ExBe_monogram.png" alt="Logo Exbe" height="60">
        </a>
        <h2 class="page-title mb-0 ms-3" style="color: #0073CF">ExbeGuardian</h2>
      </div>
      <div class="d-flex align-items-center">
        <div class="user-profile">
          <a class="nav-link dropdown-toggle text-dark" href="#" id="navbarDropdownGuardian" 
             role="button" data-bs-toggle="dropdown" aria-expanded="false">
            
            <img 
              *ngIf="fotoUsuario; else defaultFotoGuardian"
              [src]="fotoUsuario"
              class="rounded-circle object-fit-cover me-2"
              style="width: 35px; height: 35px;" />
            <ng-template #defaultFotoGuardian>
              <i class="bi bi-person-circle me-2"></i>
            </ng-template>

            <span>{{nomeUsuario}}</span>
          </a>
          
          <ul class="dropdown-menu dropdown-menu-end" aria-labelledby="navbarDropdownGuardian">
            <li><a class="dropdown-item" href="#">Meu Perfil</a></li>
            <li><a class="dropdown-item" href="#">Configurações</a></li>
            <li><hr class="dropdown-divider"></li>
            <li><a class="dropdown-item text-danger" href="/login">
              <i class="bi bi-box-arrow-right me-2"></i>Sair
            </a></li>
          </ul>
        </div>
      </div>
    </div>
  </nav>

  <nav class="navbar-modules">
    <div class="container-fluid">
      <ul class="nav nav-pills">
        <li class="nav-item">
          <a class="nav-link" 
            routerLink="/guardian/dashboard" 
            routerLinkActive="active"
            [routerLinkActiveOptions]="{exact: true}">
            <i class="bi bi-grid-1x2-fill me-2"></i>Dashboard
          </a>
        </li>
        <li class="nav-item">
          <a class="nav-link" routerLink="/guardian/estoque" routerLinkActive="active">
            <i class="bi bi-archive-fill me-2"></i>Ativos
          </a>
        </li>
        <li class="nav-item">
          <a class="nav-link" routerLink="/guardian/movimentacoes" routerLinkActive="active">
            <i class="bi bi-arrows-move me-2"></i>Movimentações
          </a>
        </li>
        <li class="nav-item">
          <a class="nav-link" routerLink="/guardian/manutencao" routerLinkActive="active">
            <i class="bi bi-tools me-2"></i>Manutenção
          </a>
        </li>
        <li class="nav-item">
          <a class="nav-link" routerLink="/guardian/relatorios" routerLinkActive="active">
            <i class="bi bi-clipboard2-data-fill me-2"></i>Relatórios
          </a>
        </li>
        <li class="nav-item">
          <a class="nav-link" routerLink="/guardian/inventario" routerLinkActive="active">
            <i class="bi bi-upc-scan me-2"></i>Inventário Físico
          </a>
        </li>
        <li class="nav-item">
          <a class="nav-link" routerLink="/guardian/configuracoes" routerLinkActive="active">
            <i class="bi bi-gear-fill me-2"></i>Configurações
          </a>
        </li>
      </ul>
    </div>
  </nav>
</header>